import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import permission from './directives/permission'
import '@/assets/styles/index.scss'; // 导入全局样式变量

// 引入富文本编辑器
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

// 引入图片查看器
import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'

// 注册权限指令
Vue.directive('permission', permission)

// 添加权限检查方法到全局
Vue.prototype.$checkPermission = function(permissionMark) {
  // 从 store 中获取权限列表
  const permissions = store.state.user.permissions || []
  
  // 递归查找按钮权限
  const hasPermission = (items) => {
    for (const item of items) {
      if (item.type === 2 && item.permission_mark === permissionMark) {
        return true
      }
      if (item.children && item.children.length) {
        if (hasPermission(item.children)) {
          return true
        }
      }
    }
    return false
  }

  return hasPermission(permissions)
}

// 有多种样式可选，也可以到对应文件中定制化
Vue.use(ElementUI);
Vue.config.productionTip = false

// 注册富文本编辑器
Vue.use(VueQuillEditor)

// 注册图片查看器
Vue.use(Viewer, {
  defaultOptions: {
    zIndex: 9999,
    navbar: true,
    title: false,
    toolbar: {
      zoomIn: true,
      zoomOut: true,
      oneToOne: true,
      reset: true,
      prev: true,
      next: true,
      rotateLeft: true,
      rotateRight: true,
      flipHorizontal: true,
      flipVertical: true,
    },
    tooltip: true,
    movable: true,
    zoomable: true,
    rotatable: true,
    scalable: true,
    transition: true,
    fullscreen: true,
    keyboard: true
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
